import { render, staticRenderFns } from "./SectionBrowser.vue?vue&type=template&id=7fbefcdc&scoped=true&"
import script from "./SectionBrowser.vue?vue&type=script&lang=js&"
export * from "./SectionBrowser.vue?vue&type=script&lang=js&"
import style0 from "./SectionBrowser.vue?vue&type=style&index=0&id=7fbefcdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbefcdc",
  null
  
)

export default component.exports